'use client'

import {Button as AntButton} from 'antd'
import React from 'react'
import styled, {css} from 'styled-components'

import {SyncOutlined} from '@ant-design/icons'

import theme, {media} from '@/src/config/theme'

export interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  outlined?: boolean
  primary?: boolean
  secondary?: boolean
  loading?: boolean
  as?: React.FC<any>
  sm?: boolean
  href?: string
  ref?: React.Ref<HTMLButtonElement>
}

export const StyledButton = styled(AntButton)<{
  $outlined?: boolean
  $primary?: boolean
  $secondary?: boolean
  $sm?: boolean
}>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  white-space: normal;
  word-break: break-word;

  height: unset;
  width: unset;

  color: ${theme.colors.text};
  padding: 6px 20px;

  background: ${theme.colors.primary};
  transition: 0.3s ease;
  box-sizing: border-box;
  border: solid 1px transparent;
  border-radius: 5px;
  font-weight: 450;

  &:hover {
    background: ${theme.colors.primary};
    border-color: solid 1px ${theme.colors.primary};
    color: ${theme.colors.text};
  }

  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed !important;

      & *:not(svg) {
        pointer-events: none;
      }
    `}

  ${props =>
    (props.$outlined &&
      css`
        background: transparent;
        border: solid 1px ${props.theme.colors.borderColor};
        color: ${props.theme.colors.text};

        ${props.$primary &&
        css`
          border-color: ${props.theme.colors.primary};
          color: ${props.theme.colors.text};

          &:hover {
            background: transparent;
          }

          [data-dark='true'],
          &[data-dark='true'] {
            color: ${props.theme.colors.primary};

            &:hover {
              border-color: ${props.theme.colors.white};
              color: ${props.theme.colors.white};
            }
          }
        `}
      `) ||
    css`
      &:hover {
        background: ${props.theme.colors.foreground};
        border: solid 1px ${props.theme.colors.borderColor};
        color: ${props.theme.colors.dark};

        ${props.$primary &&
        css`
          background: ${props.theme.colors.primary};
          border-color: ${props.theme.colors.primary};
        `}
      }
    `} ${props =>
    props.$secondary &&
    css`
      background: ${props.theme.colors.gray};
      color: ${props.theme.colors.textDark};

      &:hover {
        background: ${props.theme.colors.foreground};
        border: solid 1px ${props.theme.colors.borderColor};
        color: ${props.theme.colors.text};
      }
    `} @media ${media.md} {
  padding: 11px 22px;

  ${props =>
    props.$sm &&
    css`
      padding: 5px 10px;
    `}
}

  ${props =>
    props.$sm &&
    css`
      padding: 5px 10px;
    `}
  
  &:active {
    background: ${props => props.theme.colors.primary600};

    transform: scale(0.95);
  }
`

const Button = ({children, outlined, primary, secondary, className, onClick, sm, ref, loading, ...other}: IProps) => {
  return (
    // @ts-ignore
    <StyledButton
      {...other}
      ref={ref}
      $outlined={outlined}
      $primary={primary}
      $sm={sm}
      $secondary={secondary}
      className={className}
      loading={loading ? {icon: <SyncOutlined spin />} : undefined}
      onClick={onClick}>
      {children}
    </StyledButton>
  )
}

export default Button
